module.exports = __webpack_public_path__ + "static/img/3.8a9c4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/3.jpg
// module id = /Ace
// module chunks = 1